import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotPhoneOff = ({
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot=on,_Size=40_svg__a)">
            <path
                fill={spotColor}
                d="M4.857 17.78c1.738-5.087 7.916-9.787 13.373-11.594 5.482-1.818 11.979-.362 16.283 3.888 4.304 4.25 6.402 10.611 5.107 15.97-1.26 5.374-5.757 8.608-9.715 10.583-3.983 1.985-7.428 1.992-11.538.997-4.123-.96-8.301-2.541-10.448-6.26-2.147-3.72-4.824-8.487-3.062-13.584Z"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M8.651 21.35A32.983 32.983 0 0 1 3.534 6.965a3.333 3.333 0 0 1 3.317-3.633h5a3.334 3.334 0 0 1 3.333 2.866 21.4 21.4 0 0 0 1.167 4.684 3.333 3.333 0 0 1-.75 3.516l-2.117 2.117m24.85-14.849L1.669 38.334m16.133-16.151a26.664 26.664 0 0 0 5.683 4.333l2.117-2.117a3.333 3.333 0 0 1 3.517-.75 21.4 21.4 0 0 0 4.683 1.167 3.334 3.334 0 0 1 2.867 3.333v5a3.334 3.334 0 0 1-3.634 3.334 32.982 32.982 0 0 1-14.383-5.117 32.369 32.369 0 0 1-5.55-4.45l4.7-4.733Z"
            />
        </g>
        <defs>
            <clipPath id="Spot=on,_Size=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotPhoneOff.displayName = "SpotPhoneOff";
